import React from 'react';
import '../styles/Experience.css';
import useInView from '../hooks/useInView';

const jobs = [
    {
        jobtitle: 'Cybersecurity Analyst Internship',
        jobwhenwhere: 'Equifax Jul 2025 - Nov 2025',
        jobtasks: [
            'Investigated and validated malware and phishing alerts through IOC and log analysis.',
            'Identified suspicious patterns and potential threats during incident triage.',
            'Leveraged SIEM and EDR tools to correlate and interpret security data.',
            'Documented investigations and delivered evidence-based reports.'
        ]
    }
]

const Experience = () => {
    const [ref, visible] = useInView({ rootMargin: '-10px 0px -30% 0px', threshold: 0.08 });

    return (
        <div id='experience' ref={ref} className={`experience reveal ${visible ? 'visible' : ''}`}>

            <div className='subtitle'>
                <h2>{'Experience'}</h2>
            </div>

            {jobs.map((job, idx) => (
                <div className='job reveal-child' style={{ '--i': idx }} key={job.jobtitle || idx}>
                    <p className='jobtitle'>{job.jobtitle}</p>

                    <p className='jobwhenwhere'>{job.jobwhenwhere}</p>

                    <ul className='jobtasks'>
                        {job.jobtasks && job.jobtasks.map((task, i) => (
                            <li className='reveal-child' style={{ '--i': i + 1 }} key={i}>{task}</li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}

export default Experience;